import { createFileRoute, redirect } from "@tanstack/react-router";

import { useApp } from "../../../app/context";
import { useT } from "../../../app/i18n";
import { nextSearch } from "../../../features/auth/next";
import { TotpForm } from "../../../features/auth/totp-form";

/** Reached only from a sign-in step that asked for TOTP; the challenge token is in memory, not the URL. */
export const Route = createFileRoute("/_auth/sign-in/totp")({
  validateSearch: nextSearch,
  beforeLoad: ({ context, search }) => {
    if (context.session.mfaToken() === undefined) throw redirect({ to: "/sign-in", search });
  },
  component: TotpPage,
});

function TotpPage() {
  const { t } = useT();
  const { session } = useApp();
  const { next } = Route.useSearch();
  return (
    <>
      <h1 className="mb-2 text-xl font-semibold">{t("auth:totp.title")}</h1>
      <p className="mb-6 text-sm text-muted-foreground">{t("auth:totp.body")}</p>
      <TotpForm next={next} mfaToken={session.mfaToken() ?? ""} />
    </>
  );
}
